import * as yup from 'yup';
import { yupDateRangeValidation } from '@product-framework/components/FormFields';

const validationSchema = formatMessage =>
  yup
    .object()
    .shape({
      serviceJobNumber: yup
        .string()
        .nullable()
        .test(
          'serviceJobNumber-min-length',
          formatMessage({
            id: 'SERVICEJOBNUMBER_MIN_LENGTH',
            defaultMessage: 'Job Number must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      brandId: yup
        .string()
        .nullable()
        .test(
          'brandId-min-length',
          formatMessage({
            id: 'BRANDID_MIN_LENGTH',
            defaultMessage: 'Brand ID must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      productTypeId: yup
        .string()
        .nullable()
        .test(
          'productTypeId-min-length',
          formatMessage({
            id: 'PRODUCTTYPEID_MIN_LENGTH',
            defaultMessage: 'Product ID must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      customerAddressCity: yup
        .string()
        .nullable()
        .test(
          'customerAddressCity-min-length',
          formatMessage({
            id: 'CUSTOMERADDRESSCITY_MIN_LENGTH',
            defaultMessage: 'City must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      customerAddressState: yup.object().nullable(),
      customerAddressPostalCode: yup
        .string()
        .nullable()
        .test(
          'customerAddressPostalCode-min-length',
          formatMessage({
            id: 'CUSTOMERADDRESSPOSTALCODE_MIN_LENGTH',
            defaultMessage: 'Postal Code must be at least 2 characters',
          }),
          value => !value || value.length === 0 || value.length >= 2,
        ),
      alertTime: yupDateRangeValidation({
        testName: 'alertTime-value=required-on-operator',
        sameErrMessage: 'Alert Times cannot be same for between',
        greaterThnErrMessage:
          'Alert Time start needs to be greater than end date',
        validBetweenDateMessage:
          'Alert Time must have 2 valid dates for between',
        requiredMessage: 'Alert Time is required',
        validDateMessage: 'Alert Time should be valid date',
        useDatetimeValidation: true,
      }),
      appointmentDate: yupDateRangeValidation({
        testName: 'appointmentDate-value=required-on-operator',
        sameErrMessage: 'Appointment Dates cannot be same for between',
        greaterThnErrMessage:
          'Appointment Date start needs to be greater than end date',
        validBetweenDateMessage:
          'Appointment Date must have 2 valid dates for between',
        requiredMessage: 'Appointment Date is required',
        validDateMessage: 'Appointment Date should be valid date',
      }),
    })
    .test(
      'at-least-one-required',
      formatMessage({
        id: 'ATLEASTONE_FIELD_IS_REQUIRED',
        defaultMessage: 'At least one field is required',
      }),
      value => {
        return value &&
          typeof value === 'object' &&
          Object.values(value).length > 0 &&
          !Array.isArray(value)
          ? Object.values(value).some(val => val && val !== '')
          : false;
      },
    );

export default validationSchema;
